import { ContactUs } from '../interfaces/ContactUs';
import { ContactUsDto } from '../interfaces/dtos/ContactUsDto';
import transformContact from './transformContact';
import transformLineOfBusiness from './transformLineOfBusiness';
import transformTechnicalSupport from './transformTechnicalSupport';

export default function transformContactUs(dto: ContactUsDto): ContactUs {
  const elem = dto.sitecore.route.placeholders.Jss[0].fields;
  return {
    headOffice: transformContact(elem.headOffice),
    lineOfBusinesses: elem.lineOfBusinesses?.map((l) => transformLineOfBusiness(l)) ?? undefined,
    technicalSupport: transformTechnicalSupport(elem.technicalSupport),
  };
}
